import { round } from 'lodash';

export function formatMultiple(value: number | null) {
  if (value === null) return '-';
  return `${round(value, 2)}x`;
}

export function formatIRR(value: number | null) {
  if (value === null || value === 0) return '-';
  return `${round(value * 100, 2)}%`;
}

export function formatPct(value: number | null) {
  if (value === null) return '-';
  return `${round(value * 100, 2)}%`;
}
